<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('counter.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('counter.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('counter.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        highlight-row
        stripe
        max-height="700"
      >
          <template slot-scope="{ row }" slot="branchName">
            {{ row.branch.branch_name_en }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(row)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(row)"
            >
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('counter.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'counterIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('counter/setup', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.counter.setup.search
      },
      set(newValue) {
        this.$store.commit('counter/setup/SET_SEARCH', newValue)
        this.$store.commit('counter/setup/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { 
          title: this.$t('counter.branchName'),
          slot: 'branchName' 
        },
        { 
          title: this.$t('counter.counterName'),
          key: 'counter_name' 
        },
        { 
          title: this.$t('counter.printerName'),
          key: 'printer_receipt' 
        },
        { 
          title: this.$t('counter.ipAddress'),
          key: 'printer_ip_address' 
        },
        { 
          title: this.$t('counter.port'),
          key: 'port' 
        },
        { 
          title: this.$t('counter.type'),
          key: 'input_type' 
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('counter/setup/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('counter/setup/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('counter/setup/SET_EDIT_DATA', {})
      this.showForm = false
		},
		deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('counter/setup/destroy', record.counter_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value){
      this.$store.commit('counter/setup/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('counter/setup/RESET_STATE')
    next()
  }
}
</script>
